import React, { useState, useEffect } from 'react'
import AuthLayout from '../../../../layout/AuthLayout'
import { Box, Text, Flex, TextInput, Select, Badge, Button, Group, Pagination, Modal } from '@mantine/core'
import { useDispatch } from 'react-redux'
import { updateRoute } from '../../../../store/dataRoute'
import { deleteUser, deletUserPermanent, getListUsers, getListUsersInactive, restoreUser } from '../../../../services/users'
import classes from '../../../../assets/module-css/AdminLayout.module.css'
import { IconPlus } from '@tabler/icons-react'
import UserList from '../../../../component/pages/Users/UserList'
import LoadingData from '../../../../component/ui/LoadingData'
import NoData from '../../../../component/ui/NoData'
import { modalDeleteData } from '../../../../component/ui/Prompt/modalDeleteData'
import { modalRestoreUser } from '../../../../component/ui/Prompt/modalRestoreUser'
import { modalDeletePermanentUser } from '../../../../component/ui/Prompt/modalDeletePermanentUser'
// import ModalAddUser from '../../../../component/pages/Users/ModalAddUser'
import FormAddUser from '../../../../component/pages/Users/FormAddUser'

const defaultParameter = {
  'filter[deleted_at][null]': true,
  'sort': '-created_at',
  'include': 'items,invoices,platforms,parents,childs,codes,verificationStatus,documentVerification,addresses,memberships',
  'page[num]': 1,
  'page[limit]': 10,
}

const defaultFilterBadge = [
  {
    label: 'All',
    params: 'default',
    value: null,
    count: 0
  },
  {
    label: 'Active',
    params: 'filter[active][is]',
    value: 1,
    count: 0
  },
  {
    label: 'Inactive',
    params: 'filter[active][is]',
    value: 0,
    count: 0
  },
  {
    label: 'Need Identity Approval',
    params: 'filter[verificationStatus.id][is]',
    value: 53,
    count: 0
  },
  {
    label: 'Verified',
    params: 'filter[verificationStatus.id][is]',
    value: 51,
    count: 0
  },
  {
    label: 'Deleted User',
    params: 'filter[deleted_at][null]',
    value: false,
    count: 0
  },
]

const defaultMembership = ['Local Seller', 'VIP Member', 'Premium Member', 'Basic Member', 'Admin', 'Partner', 'Special Client', 'Importer', 'Verified Seller']


const AllListUser = () => {
  const dispatch = useDispatch()
  const [params, setParams] = useState(defaultParameter)
  const [userList, setUserList] = useState([])
  const [totalUser, setTotalUser] = useState(0)
  // const [count, setCount] = useState(0)
  // const [approvalCount, setApprovalCount] = useState(0)
  const [selectedBadgeFilter, setSelectedBadgeFilter] = useState('All')
  const [badgeFilter, setBadgeFilter] = useState(defaultFilterBadge)
  const [loading, setLoading] = useState(true)
  const [openModalAddUser, setOpenModalAddUser] = useState(false)

  const mappingRoute = [
    {
      label: '/',
      route: null
    },
    {
      label: 'users',
      route: null
    },
    {
      label: 'all',
      route: null
    },
  ]

  const handleGetUserList = async () => {
    setLoading(true)
    try {
      const response = params['filter[deleted_at][null]'] ? await getListUsers(params)
        : await getListUsersInactive(params)

      const { data, meta } = response.data
      const countData = meta.pagination.total

      const dataList = data
      const remapData = dataList.map((value) => {
        const remap = {
          active: value.attributes.active,
          id: value.attributes.id,
          name: value.attributes.name,
          email: value.attributes.email,
          phone: value.attributes.phone,
          memberships: [],
          countryCatalogsName: [],
          lastLogin: value.attributes.last_login,
          lastSession: value.attributes.last_session,
          countries: value.attributes.country_catalog_names.length > 0 ? value.attributes.country_catalog_names : ['-'],
          countrySignup: '',
          verifiedIdentity: value.relationships.verificationStatus.length > 0 ? value.relationships.verificationStatus[0].id : null,
          memberStartDate: value.attributes.membership ? value.attributes.membership.start_at : '',
          memberExpired: value.attributes.membership ? value.attributes.membership.expired_at : '',
          referredBy: '-',
          totalOrder: value.attributes.total_orders,
          totalProducts: value.attributes.total_products_by_url,
        }

        // country signup
        if (value.attributes.country_signup) {
          remap.countrySignup = response.data.included.signupcountry[value.attributes.country_signup].attributes.name
        } else {
          remap.countrySignup = '-'
        }

        // set refered By
        if (value.relationships.parents.length > 0) {
          const idReferral = value.relationships.parents[0].id
          remap.referredBy = response.data.included.parents[idReferral].attributes.name
        }

        // set memberships
        if (value.relationships.memberships.length > 0) {
          const dataMembership = value.relationships.memberships.map((e) => {
            return response.data.included.memberships[e.id].attributes.name
          })
          remap.memberships = dataMembership
        }

        // set country catalogs
        if (value.attributes.country_catalog_names.length > 0) {
          remap.countryCatalogsName = value.attributes.country_catalog_names
        }
        return remap
      })
      setUserList(remapData)
      setTotalUser(countData)
    } catch (error) {
      console.log(error)
      setUserList([])
      setTotalUser(0)

    } finally {
      setLoading(false)
    }
  }

  const handleGetTotalNeedApprovalUser = async () => {
    const params = {
      'filter[verificationStatus.id][is]': 53,
      'filter[deleted_at][null]': true,
      'page[num]': 1,
      'page[limit]': 1,
      'fields[user]': 'id'
    }
    try {
      const response = await getListUsers(params)
      const { meta } = response.data
      const countData = meta?.pagination?.total || 0

      // update count in badge filter
      const remapBadge = defaultFilterBadge.map((val) => {
        if (val.label === 'Need Identity Approval') {
          return { ...val, count: countData }
        }
        return val
      })

      setBadgeFilter(remapBadge)
    } catch (error) {
      console.log(error)
    }
  }

  const actions = {
    delete: (val) => {
      modalDeleteData('User', val.id, val.name, deleteUser, handleGetUserList)
    },
    restore: (val) => {
      const payload = { restore_ids: [val.id] }
      modalRestoreUser('User', payload, val.name, restoreUser, handleGetUserList)
    },
    permanentDelete: (val) => {
      const payload = { id: val.id }
      modalDeletePermanentUser('User', payload, val.name, deletUserPermanent, handleGetUserList)
    }
  }

  const handleAction = (val, type) => {
    return actions[type](val)
  }

  useEffect(() => {
    dispatch(updateRoute({ 'data': mappingRoute }))
    // eslint-disable-next-line
  }, [dispatch])

  useEffect(() => {
    handleGetUserList()
    // eslint-disable-next-line
  }, [params])

  useEffect(() => {
    handleGetTotalNeedApprovalUser()
  }, [])


  const handleChangePage = (val) => {
    // eslint-disable-next-line
    setParams((oldVal) => ({ ...oldVal, ['page[num]']: val }))
  }

  const handleFilter = (name, val) => {
    setParams((oldVal) => ({ ...oldVal, [name]: val }))
    handleChangePage(1)
  }

  const onCloseModalAddUser = () => {
    setOpenModalAddUser(false)
  }

  const mappingFilterBadge = (dataBadge) => {

    const handleFilterBadge = (badge) => {
      setSelectedBadgeFilter(badge.label)

      setParams(defaultParameter)
      if (badge.label !== 'All') {
        handleFilter(`${badge.params}`, badge.value)
      }
    }

    const mappingBadge = dataBadge.map((val, index) => {
      return (
        <Badge key={index} variant={val.label === selectedBadgeFilter ? '' : 'outline'} size='lg' onClick={() => handleFilterBadge(val)} style={{ textTransform: 'capitalize', fontWeight: '400', cursor: 'pointer' }}>
          {val.label} {val.count > 0 ? `(${val.count})` : ''}
        </Badge>
      )
    })

    return mappingBadge
  }

  return (
    <AuthLayout>
      <Box my={20}>
        <Box>
          <Flex justify='space-between' align="center" mb={30}>
            <Text className={classes.titleLayout}>All List Users</Text>
            <Button size='xs' leftSection={<IconPlus size={14} />} onClick={() => setOpenModalAddUser(true)}>Add New User</Button>
          </Flex>
          <Group gap='sm' mb={40}>
            {mappingFilterBadge(badgeFilter)}
          </Group>
          <Flex direction={{ base: 'column', sm: 'row' }} gap={{ base: 'sm', sm: 'lg' }} justify={{ base: 'center', lg: 'start' }}>
            <Select
              name='memberships'
              placeholder='Select Memberships'
              data={defaultMembership}
              onChange={(val) => handleFilter('filter[memberships.name][like]', val)}
              clearable
              size='xs'
            />
            <TextInput
              placeholder='Search Username. . .'
              name="username"
              onChange={(val) => handleFilter('filter[name][like]', val.target.value)}
              size='xs'
            />
            <TextInput
              placeholder='Search Email. . .'
              name="email"
              onChange={(val) => handleFilter('filter[email][like]', val.target.value)}
              size='xs'
            />
            <TextInput
              placeholder='Search Phone. . .'
              name="email"
              onChange={(val) => handleFilter('filter[phone][like]', val.target.value)}
              size='xs'
            />
          </Flex>
        </Box>

        <Group my={10} gap='xs'>
          <Text fz={12}>Total Data Found: </Text>
          <Text fz={12} fw='bold'>{loading ? 0 : totalUser} Users </Text>
        </Group>

        <Box my={30}>
          {loading ? <LoadingData /> : userList.length > 0 ? <UserList data={userList} params={params} actionMethod={handleAction} /> : <NoData />}
        </Box>

        <Flex justify='end'>
          <Pagination size='sm' onChange={handleChangePage} total={Math.ceil(totalUser / params['page[limit]']) || 0} />
        </Flex>
      </Box>
      <Modal
        opened={openModalAddUser}
        onClose={onCloseModalAddUser}
        centered
        closeOnClickOutside={false} 
        size='xl'
        title={<Text fw='Bold'>Create New User</Text>} 
        withCloseButton={false}>
        <FormAddUser onCloseModal={onCloseModalAddUser} reloadList={handleGetUserList} />
      </Modal>
      {/* <ModalAddUser opened={opened} close={() => setOpened(false)} onSuccess={handleGetUserList} /> */}
    </AuthLayout>
  )
}

export default AllListUser